import React from 'react';
import { parameterizedURLAccessToken,isSet } from '../../../../Utils/CommonFunctions';
import {callPOST } from '../../../../Utils/ApiUtil';
import {
  validateFilesWithinSizeLimit,
  reportFileSizeValidationError,
} from '../../../../Utils/FileUploadValidation';
// import elementsProperties from './elementsProperties';

const Upload = (props)=>{
    const {elementData,uploadFileRef,fileChangeHandler} = props;      
    
    let defaultImg = '/assets/img/temp-banner.png';
    let imageBasePath = 'files/download?fileId=';
    let imagePath = (isSet(elementData.attributes.src,null)!==null)?parameterizedURLAccessToken(elementData.attributes.src):defaultImg;
    const uploadImageFiles = (e)=> {
        const files = e.target.files;
        const sizeValidation = validateFilesWithinSizeLimit(files);
        if (!sizeValidation.valid) {
          reportFileSizeValidationError(sizeValidation.errorMsg, {
            failMessage: props.failMessage,
          });
          return;
        }
        if(files.length > 0) {              
          Object.entries(files).map(([key, fileItem]) => {
            const formData = new FormData();            
            formData.append("upload_file", fileItem);
            const APIURL = 'files/upload';
            callPOST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
            .then(res => {    
              if(res.status==200){                        
                const response = res.data;
              if(response.code===200){
                const responseData =  response.data;
                const imgPath = imageBasePath+responseData;
                props.changeHandler('.attributes','src',imgPath);
                }else{
                
                }                                                
              }else{
                
              }
            })
            .catch(err => {                        
            })
          })
        }
    }

    return(
        <>
            <div className="border" style={{"border-radius":"0.25em","padding":"5px","width":"100%"}}>
               <div className="position-relative">
                  <input 
                      type="file" 
                      accept=".png, .jpg, .jpeg" 
                      id="Upload" 
                      ref={uploadFileRef}
                      onChange={uploadImageFiles} 
                      style={{"display":"none"}} 
                  />
                  <div className="border-bottom card-title mb-2 cursor-pointer">   
                    <label 
                        htmlFor="Upload" 
                        onClick={fileChangeHandler}>                
                        <div className="text-right cursor-pointer"><i className="fas fa-upload secondary_color"></i> <small>Upload New</small></div>
                    </label>
                  </div>
               </div>
            
               <div className="row">
                  <div className="col-12">
                     <div>
                        <div className="d-flex align-items-center justify-content-between">
                           <div className="">
                                <img src={imagePath} className="" style={{"height":"50px"}} />                                
                           </div> 
                            <div className="pt-1">
                                {/*<small className="text-muted"><i className="fas fa-download fa-lg cursor-pointer"></i></small>&nbsp;&nbsp;*/}
                                <small className="text-muted" onClick={()=>props.changeHandler('.attributes','src','')}><i className="far fa-trash-alt fa-lg cursor-pointer"></i></small>
                            </div>
                        </div>
                        <div className="separator-dashed m-1"></div>
                     </div>
                  </div>
               </div>
            </div>
        </>
    )
}

export default Upload;